module.exports = __webpack_public_path__ + "img/Wp_2058.54918ab8.png";